import { Skeleton } from '@sandtech-hub-monorepo/ui-kit';
import React from 'react';

export const NotificationItemSkeleton = () => (
  <div className="flex gap-4 p-2 mt-4 border border-border min-h-[122px] rounded-lg">
    <Skeleton className="h-10 w-10 rounded-full" />
    <div className="flex flex-1 flex-col gap-2">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  </div>
);
